<div class="game-wrap">
  <div class="game-container">
    <app-district-page
      *ngIf="currentPage === 'district'"
      [currentDistrict]="currentDistrict"
      (backClick)="patchState({ currentPage: 'taerra' })"
      (selectedDistrict)="onChangeCurrentDistrict($event)"
      (navigateToShop)="onNavigateToShop($event)"
    ></app-district-page>
    <app-landing-page
      *ngIf="currentPage === 'landing'"
      (beginClick)="patchState({ currentPage: 'taerra' })"
    ></app-landing-page>
    <app-taerra-page
      *ngIf="currentPage === 'taerra'"
      (callFileClick)="patchState({ currentPage: 'call-file' })"
      (districtInfoClick)="navigateToDistrictInfo($event)"
      (quarterOneEndTriggered)="endQuarterOne($event)"
      (quarterTwoEndTriggered)="patchState({ currentPage: 'q2-feedback' })"
      (quarterThreeEndTriggered)="patchState({ currentPage: 'q3-feedback' })"
      (quarterFourEndTriggered)="patchState({ currentPage: 'q4-feedback' })"
      (districtClick)="navigateToDistrict($event)"
      (navigateToKpi)="patchState({ currentPage: 'kpi' })"
      (navigateToNews)="patchState({ currentPage: 'news' })"
      (aamClick)="patchState({ currentPage: 'aam' })"
    ></app-taerra-page>
    <app-call-file-page
      *ngIf="currentPage === 'call-file'"
      [currentShop]="currentShop"
      (closeClick)="onCallFileCloseClick($event)"
      (quarterEndTriggered)="endQuarterOne($event)"
    ></app-call-file-page>
    <app-district-info-page
      *ngIf="currentPage === 'district-info'"
      [district]="currentInfoDistrict"
      (closeClick)="patchState({ currentPage: 'taerra' })"
    ></app-district-info-page>
    <app-q1-feedback-all-correct-page
      *ngIf="currentPage === 'q1-feedback-all-correct'"
      (continueClick)="patchState({ currentPage: 'taerra' })"
    ></app-q1-feedback-all-correct-page>
    <app-q1-feedback-enough-correct-page
      *ngIf="currentPage === 'q1-feedback-enough-correct'"
      [correctSelections]="q1CorrectSelections"
      [incorrectShops]="q1IncorrectShops"
      (continueClick)="patchState({ currentPage: 'taerra' })"
      (navigateToSlider)="q1NavigateToSlider($event)"
    ></app-q1-feedback-enough-correct-page>
    <app-q1-feedback-some-correct-page
      *ngIf="currentPage === 'q1-feedback-some-correct'"
      [correctSelections]="q1CorrectSelections"
      [incorrectShops]="q1IncorrectShops"
      (continueClick)="patchState({ currentPage: 'taerra' })"
      (navigateToSlider)="q1NavigateToSlider($event)"
    ></app-q1-feedback-some-correct-page>
    <app-call-file-single-page
      *ngIf="currentPage === 'call-file-single'"
      [storeId]="currentShop"
      (closeClick)="patchState({ currentPage: latestQ1FeedbackPage })"
    ></app-call-file-single-page>
    <app-news-page
      *ngIf="currentPage==='news'"
      (closeClick)="patchState({ currentPage: 'taerra' })"
    ></app-news-page>
    <app-kpi-page
      *ngIf="currentPage==='kpi'"
      (closeClick)="patchState({ currentPage: 'taerra' })"
    ></app-kpi-page>
    <app-shop-page
      *ngIf="currentPage === 'shop'"
      [shopId]="currentShop"
      (closeClick)="patchState({ currentPage: 'district' })"
    ></app-shop-page>
    <app-q2-feedback-page
      *ngIf="currentPage === 'q2-feedback'"
      (continueClick)="patchState({ currentPage: 'taerra' })"
    ></app-q2-feedback-page>
    <app-q3-feedback-page
      *ngIf="currentPage === 'q3-feedback'"
      (continueClick)="patchState({ currentPage: 'taerra' })"
    ></app-q3-feedback-page>
    <app-q4-feedback-page
      *ngIf="currentPage === 'q4-feedback'"
      (continueClick)="endSimulation()"
    ></app-q4-feedback-page>
    <app-aam-page
      *ngIf="currentPage === 'aam'"
      (closeClick)="patchState({ currentPage: 'taerra' })"
    ></app-aam-page>
    <ng-container
      *ngIf="(currentPage === 'taerra' || currentPage === 'district' || currentPage === 'shop') 
      && sidePanelData$ | async as panelData"
    >
      <app-side-panel
        class="side-panel"
        [quarter]="panelData.quarter"
        [time]="panelData.time"
        [mcc]="panelData.mcc"
        [tposm_p1]="panelData.tposm_p1"
        [tposm_p4]="panelData.tposm_p4"
        [tposm_p5]="panelData.tposm_p5"
        [tposm_full]="panelData.tposm_full"
        [incentives]="panelData.incentives"
        [disabled]="panelData.disabled"
      ></app-side-panel>
    </ng-container>
  </div>
</div>